import { TEAM_IMAGE_URLS } from '../components/about/teamMembersData';
import { shouldDeferHeavyVisuals } from './shouldSkipDoorIntro';

const preloaded = new Set();

/**
 * Warm the browser cache for About Us team photos (runs before / while section paints).
 */
export function preloadTeamImages(urls = TEAM_IMAGE_URLS) {
  if (typeof document === 'undefined' || shouldDeferHeavyVisuals()) return;

  urls.forEach((src) => {
    if (!src || preloaded.has(src)) return;
    preloaded.add(src);

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);

    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  });
}

/** Start loading About page + team assets before navigation. */
export function prefetchAboutUsRoute() {
  if (shouldDeferHeavyVisuals()) return;
  preloadTeamImages();
  import('../components/about/AboutUs').catch(() => {});
}
